<div class="row">
	<div id="divTestSpecificationDetails" class="col-md-12">
		<h4>Details for test specification {{ testSpecification?.itemNo }} {{ testSpecification?.name }}</h4>
		<table class="table">
			<tbody>
				<tr>
					<td width="20%">Test specification UID</td>
					<td class="bold">{{ testSpecification?.uid }}</td>
				</tr>
				<tr>
					<td>Version number</td>
					<td>
						<mat-form-field class="dropdown-padding">
							<select matNativeControl [ngModel]="selectedTestSpecificationVersion" (change)="getVersion($event.target.value)">
								<option *ngFor="let version of testSpecification?.versions" value="{{ version.versionNo }}">
									<span *ngIf="!version.validTo">
										&nbsp;{{ version.versionNo }}&nbsp;&nbsp;&nbsp;&nbsp;({{ version.regTime | date: 'yyyy-MM-dd HH:mm:ss' }} - {{ version.regBy.toUpperCase() }}) latest
									</span>
									<span *ngIf="version.validTo">
										&nbsp;{{ version.versionNo }}&nbsp;&nbsp;&nbsp;&nbsp;({{ version.regTime | date: 'yyyy-MM-dd HH:mm:ss' }} - {{ version.regBy.toUpperCase() }})
									</span>
								</option>
							</select>
						</mat-form-field>
					</td>
				</tr>
				<tr>
					<td>Creation time for this version</td>
					<td class="bold">{{ testSpecification?.regTime | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
				</tr>
				<tr>
					<td>Owner</td>
					<td class="bold">{{ testSpecification?.owners?.join(', ') }}</td>
				</tr>
				<tr>
					<td>Test analyses</td>
					<td>
						<div class="col-md-12 no-margin no-padding" *ngIf="testSpecification?.testAnalyses?.length > 0">
							<table mat-table [dataSource]="dataSource">
								<ng-container matColumnDef="itemNo">
									<th mat-header-cell *matHeaderCellDef width="10%">ItemNo</th>
									<td mat-cell *matCellDef="let data">{{ data.itemNo }}</td>
								</ng-container>
								<ng-container matColumnDef="name">
									<th mat-header-cell *matHeaderCellDef width="20%">Name</th>
									<td mat-cell *matCellDef="let data">{{ data.name }}</td>
								</ng-container>
								<ng-container matColumnDef="version">
									<th mat-header-cell *matHeaderCellDef width="5%">Version</th>
									<td mat-cell *matCellDef="let data">{{ data.version }}</td>
								</ng-container>
								<ng-container matColumnDef="regTime">
									<th mat-header-cell *matHeaderCellDef width="10%">Creation time</th>
									<td mat-cell *matCellDef="let data">{{ data.regTime | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
								</ng-container>
								<ng-container matColumnDef="regBy">
									<th mat-header-cell *matHeaderCellDef width="10%">Created by</th>
									<td mat-cell *matCellDef="let data">{{ data.regBy.toUpperCase() }}</td>
								</ng-container>
								<ng-container matColumnDef="uid">
									<th mat-header-cell *matHeaderCellDef width="10%">Test analysis UID</th>
									<td mat-cell *matCellDef="let data">{{ data.uid }}</td>
								</ng-container>
								<tr mat-header-row *matHeaderRowDef="displayedTestAnalysesColumns"></tr>
								<tr
									mat-row
									*matRowDef="let row; columns: displayedTestAnalysesColumns"
									[ngClass]="{ hovered: row.hovered }"
									(focus)="row.hovered = true"
									(mouseover)="row.hovered = true"
									(blur)="row.hovered = false"
									(mouseout)="row.hovered = false"
								></tr>
							</table>
						</div>
						<div *ngIf="testSpecification?.testAnalyses?.length === 0">
							<span class="scania-icon-info xs"></span>
							<span class="bold">There are no test analyses for this test specification</span>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
